// Audit mutations (PG server). The server owns scoring: completeAuditRun computes
// score/percentage/passed and auto-raises an audit_finding Issue on failure.

import {
    AUDIT_TEMPLATE_FIELDS_GQL,
    AUDIT_QUESTION_FIELDS_GQL,
    AUDIT_RUN_FIELDS_GQL,
    AUDIT_ASSIGNMENT_FIELDS_GQL,
    AUDIT_ANSWER_FIELDS_GQL,
} from "./queries";

export const createAudit = /* GraphQL */ `
  mutation createAudit($input: CreateAuditTemplateInput!) {
    createAudit(input: $input) { ${AUDIT_TEMPLATE_FIELDS_GQL} }
  }
`;

export const updateAudit = /* GraphQL */ `
  mutation updateAudit($input: UpdateAuditTemplateInput!) {
    updateAudit(input: $input) { ${AUDIT_TEMPLATE_FIELDS_GQL} }
  }
`;

export const deleteAudit = /* GraphQL */ `
  mutation deleteAudit($id: ID!) {
    deleteAudit(id: $id) { ${AUDIT_TEMPLATE_FIELDS_GQL} }
  }
`;

export const createAuditQuestion = /* GraphQL */ `
  mutation createAuditQuestion($input: CreateAuditQuestionInput!) {
    createAuditQuestion(input: $input) { ${AUDIT_QUESTION_FIELDS_GQL} }
  }
`;

export const updateAuditQuestion = /* GraphQL */ `
  mutation updateAuditQuestion($input: UpdateAuditQuestionInput!) {
    updateAuditQuestion(input: $input) { ${AUDIT_QUESTION_FIELDS_GQL} }
  }
`;

export const deleteAuditQuestion = /* GraphQL */ `
  mutation deleteAuditQuestion($id: ID!) {
    deleteAuditQuestion(id: $id) { ${AUDIT_QUESTION_FIELDS_GQL} }
  }
`;

export const startAuditRun = /* GraphQL */ `
  mutation startAuditRun($input: StartAuditRunInput!) {
    startAuditRun(input: $input) { ${AUDIT_RUN_FIELDS_GQL} }
  }
`;

export const createAuditAssignment = /* GraphQL */ `
  mutation createAuditAssignment($input: CreateAuditAssignmentInput!) {
    createAuditAssignment(input: $input) { ${AUDIT_ASSIGNMENT_FIELDS_GQL} }
  }
`;

export const updateAuditAssignment = /* GraphQL */ `
  mutation updateAuditAssignment($input: UpdateAuditAssignmentInput!) {
    updateAuditAssignment(input: $input) { ${AUDIT_ASSIGNMENT_FIELDS_GQL} }
  }
`;

export const deleteAuditAssignment = /* GraphQL */ `
  mutation deleteAuditAssignment($id: ID!) {
    deleteAuditAssignment(id: $id) { ${AUDIT_ASSIGNMENT_FIELDS_GQL} }
  }
`;

export const startAssignedAuditRun = /* GraphQL */ `
  mutation startAssignedAuditRun($assignmentId: ID!) {
    startAssignedAuditRun(assignmentId: $assignmentId) { ${AUDIT_RUN_FIELDS_GQL} }
  }
`;

export const saveAuditAnswer = /* GraphQL */ `
  mutation saveAuditAnswer($input: SaveAuditAnswerInput!) {
    saveAuditAnswer(input: $input) { ${AUDIT_ANSWER_FIELDS_GQL} }
  }
`;

export const completeAuditRun = /* GraphQL */ `
  mutation completeAuditRun($id: ID!) {
    completeAuditRun(id: $id) { ${AUDIT_RUN_FIELDS_GQL} }
  }
`;

export const completeAssignedAuditRun = /* GraphQL */ `
  mutation completeAssignedAuditRun($assignmentId: ID!, $auditRunId: ID!) {
    completeAssignedAuditRun(assignmentId: $assignmentId, auditRunId: $auditRunId) { ${AUDIT_RUN_FIELDS_GQL} }
  }
`;
